import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
// NOTE Do not import like that it seems that then they are constants and the state is shared
// import { state, getters, actions, mutations } from '@shared/store/abstract-form.store';

import { Module } from 'vuex';
import { bpcApi } from '@core/services/bpc-api.service';

const bpcRouterHelper = new BPCApiRouteHelper();

//  We can extends abstract state getters actions and muttations
//  For example:

const state = {
  invoicesCount: null,
  creditNotesCount: null,
  ticketsCount: null,

  // extends with new prop and methods here
};

const getters = {
  // Invoices
  invoicesCount: (state): AnyEntity[] => {
    return state.invoicesCount ? state.invoicesCount : null;
  },
  invoicesInDraft: (state): AnyEntity[] => {
    return state.invoicesCount?.['in_draft'];
  },
  invoicesInTopay: (state): AnyEntity[] => {
    return state.invoicesCount?.['in_to_pay'];
  },
  // Credit Notes
  creditNotesCount: (state): AnyEntity[] => {
    return state.creditNotesCount ? state.creditNotesCount : null;
  },
  creditNotesInDraft: (state): AnyEntity[] => {
    return state.creditNotesCount?.['in_draft'];
  },
  creditNotesInTopay: (state): AnyEntity[] => {
    return state.creditNotesCount?.['in_to_pay'];
  },
  // Tickets
  ticketsCount: (state): AnyEntity[] => {
    return state.ticketsCount ? state.ticketsCount : null;
  },
  ticketsInDraft: (state): AnyEntity[] => {
    return state.ticketsCount?.['in_draft'];
  },
  ticketsInTopay: (state): AnyEntity[] => {
    return state.ticketsCount?.['in_to_pay'];
  },
};
// Async changes
const actions = {
  getInvoicesCount: async (
    { commit, getters },
    data: {
      invoicesCount: [];
    },
  ): Promise<void> => {
    const path = `${bpcRouterHelper.getEntityPath(
      'invoices',
      'raw',
    )}/count-invoices-in-draft-and-to-pay`;

    const queryConfig = {
      params: {
        invoice_type: 'invoice',
      },
    };

    bpcApi.get(path, queryConfig).subscribe(res => {
      commit('getInvoicesCount', res);
    });
  },

  getCreditNotesCount: async (
    { commit, getters },
    data: {
      creditNotesCount: [];
    },
  ): Promise<void> => {
    const path = `${bpcRouterHelper.getEntityPath(
      'invoices',
      'raw',
    )}/count-invoices-in-draft-and-to-pay`;

    const queryConfig = {
      params: {
        invoice_type: 'credit_note',
      },
    };

    bpcApi.get(path, queryConfig).subscribe(res => {
      commit('getCreditNotesCount', res);
    });
  },
  getTicketsCount: async (
    { commit, getters },
    data: {
      ticketsCount: [];
    },
  ): Promise<void> => {
    const path = `${bpcRouterHelper.getEntityPath(
      'invoices',
      'raw',
    )}/count-invoices-in-draft-and-to-pay`;

    const queryConfig = {
      params: {
        invoice_type: 'ticket',
      },
    };

    bpcApi.get(path, queryConfig).subscribe(res => {
      commit('getTicketsCount', res);
    });
  },
};
// Sync changes
const mutations = {
  getInvoicesCount: (state, invoicesCount: []): void => {
    state.invoicesCount = invoicesCount;
  },
  getCreditNotesCount: (state, creditNotesCount: []): void => {
    state.creditNotesCount = creditNotesCount;
  },
  getTicketsCount: (state, ticketsCount: []): void => {
    state.ticketsCount = ticketsCount;
  },
};

export const InvoiceCountsStoreModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
